import { Component, OnInit, Renderer2, ElementRef, Input } from '@angular/core';

@Component({
  selector: 'app-script-loader',
  template: ''
})
export class ScriptLoaderComponent implements OnInit {
  /**
   * Source of the script to load
   * @var {string}
   */
  @Input() src: string;

  /**
   * Component constructor
   *
   * @param renderer
   * @param element
   */
  constructor(
    private renderer: Renderer2,
    private element: ElementRef
  ) { }

  /**
   * On init method
   */
  public ngOnInit() {
    if (this.src) {
      this.loadScript(this.src);
    }
  }

  /**
   * Loads a script and appends it to the DOM
   *
   * @param src
   *
   * @returns {void}
   */
  public loadScript(src: string): void {
    const script = this.renderer.createElement('script');

    script.type = 'text/javascript';
    script.src = src;

    this.renderer.appendChild(this.element.nativeElement, script);
  }
}
